import styles from "./MenuIcon.module.css";

interface Props {
  theme?: "white" | "red";
  open?: boolean;
  hover?: boolean;
  className?: string;
}

export default function MenuIcon({ theme = "white", open = false, hover = false, className }: Props) {
  const rootClass = [
    styles.root,
    theme === "red" ? styles.themeRed : styles.themeWhite,
    open ? styles.open : hover ? styles.hovered : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <svg className={rootClass} width="36" height="36" viewBox="0 0 36 36" fill="none" aria-hidden>
      <g className={styles.bars}>
        <path
          d="M5.625 9H30.375M5.625 18H30.375M5.625 27H30.375"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.plus}>
        <path
          d="M5.13392 18.3331H18.3333M18.3333 18.3331H31.5326M18.3333 18.3331V5.13379M18.3333 18.3331V31.5324"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.close}>
        <path
          d="M9 27.6667L18.3333 18.3333M18.3333 18.3333L27.6667 9M18.3333 18.3333L9 9M18.3333 18.3333L27.6667 27.6667"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
